import script from "./TransactionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsSection.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsSection.vue?vue&type=style&index=0&id=0ef57c46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef57c46"]])

export default __exports__